import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import {showFailToast} from 'vant'

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        component: () => import("../views/layout/index.vue"),
        children: [
            {
                path: "",
                name: "home",
                component: () => import("../views/layout/home/index.vue"),
            },
            {
                path: "/company",
                name: "company",
                component: () => import("../views/layout/company/index.vue"),
            },
            {
                path: "/product",
                name: "product",
                component: () => import("../views/layout/product/index.vue"),
            },
            {
                path: "/productVrbt",
                name: "productVrbt",
                component: () => import("../views/layout/productVrbt/index.vue"),
            },
            {
                path: "/join",
                name: "join",
                component: () => import("../views/layout/join/index.vue"),
            },
            {
                path: "/agreement",
                name: "agreement",
                component: () => import("../views/layout/agreement/index.vue"),
                meta: {
                    title: "用户协议",
                },
            },
            {
                path: "/privacy",
                name: "privacy",
                component: () => import("../views/layout/privacy/index.vue"),
                meta: {
                    title: "隐私政策",
                },
            },
            {
                path: "/privacyAI",
                name: "privacyAI",
                component: () => import("../views/layout/privacyAI/index.vue"),
                meta: {
                    title: "AI小画家隐私政策",
                },
            },
            {
                path: "/minority",
                name: "minority",
                component: () => import("../views/layout/minority/index.vue"),
                meta: {
                    title: "未成年人隐私政策保护",
                },
            },
            {
                path: "/dispute",
                name: "dispute",
                component: () => import("../views/layout/dispute/index.vue"),
                meta: {
                    title: "纠纷处理",
                },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach(((to, from, next) => {
    if (to.meta.requireAuth){
        if (window.localStorage.getItem('user')){
            next()
        }else{
            showFailToast("未登录")
            next({path:'/login'})
        }
    }
    next()
}))
export default router;
